import React from 'react';

import { createSafeContext } from '@mantine/core';

// TODO: @Dylan-Brandenburg Combine this type with the one in FilterSearch
export type FilterSearchContextValue = {
  children?: React.ReactNode | React.ReactNode[];
  onReset?: () => void;
  onSearch?: () => void;
  rootRef?: React.RefObject<HTMLDivElement> | null;
  setRootRef?: React.Dispatch<React.SetStateAction<React.RefObject<HTMLDivElement> | null>>;
};

export const [FilterSearchProvider, useFilterSearchContext] =
  createSafeContext<FilterSearchContextValue>(
    'FilterSearch Context component was not found in tree'
  );
